export const statuses = {
  FINISHED: 'Concluida',
  CANCELLED: 'Cancelada',
  ACCEPTED: 'Aceptada',
  SENT_PENDING: 'Pendiente de envío',
};